import { I as Icon, _ as _extends } from './Icon-465858dc.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const ArrowLeft = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement("path", {
      d: "M20.8957 11.897c0-.5523-.4477-1-1-1H6.5173l3.245-3.245c.3906-.3906.3906-1.0238 0-1.4143-.3905-.3905-1.0237-.3905-1.4142 0l-4.9517 4.9517a.9958.9958 0 00-.2868.5964.9982.9982 0 00.2868.818l4.9515 4.9515c.3905.3905 1.0237.3905 1.4142 0 .3905-.3906.3905-1.0237 0-1.4143l-3.244-3.244h13.3776c.5523 0 1-.4477 1-1z"
    }),
    filledrtl: /*#__PURE__*/React.createElement("path", {
      d: "M3.1035 11.897c0-.5523.4477-1 1-1H17.482l-3.245-3.245c-.3905-.3906-.3905-1.0238 0-1.4143.3905-.3905 1.0237-.3905 1.4142 0l4.9517 4.9517a.9955.9955 0 01.2868.5964.9983.9983 0 01-.2868.818l-4.9514 4.9515c-.3906.3905-1.0237.3905-1.4143 0-.3905-.3906-.3905-1.0237 0-1.4143l3.2441-3.244H4.1035c-.5523 0-1-.4477-1-1z"
    }),
    stroke: /*#__PURE__*/React.createElement("path", {
      d: "M20.8957 11.897c0-.5523-.4477-1-1-1H6.5173l3.245-3.245c.3906-.3906.3906-1.0238 0-1.4143-.3905-.3905-1.0237-.3905-1.4142 0l-4.9517 4.9517a.9958.9958 0 00-.2868.5964.9982.9982 0 00.2868.818l4.9515 4.9515c.3905.3905 1.0237.3905 1.4142 0 .3905-.3906.3905-1.0237 0-1.4143l-3.244-3.244h13.3776c.5523 0 1-.4477 1-1z"
    }),
    strokertl: /*#__PURE__*/React.createElement("path", {
      d: "M3.1035 11.897c0-.5523.4477-1 1-1H17.482l-3.245-3.245c-.3905-.3906-.3905-1.0238 0-1.4143.3905-.3905 1.0237-.3905 1.4142 0l4.9517 4.9517a.9955.9955 0 01.2868.5964.9983.9983 0 01-.2868.818l-4.9514 4.9515c-.3906.3905-1.0237.3905-1.4143 0-.3905-.3906-.3905-1.0237 0-1.4143l3.2441-3.244H4.1035c-.5523 0-1-.4477-1-1z"
    })
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
ArrowLeft.displayName = "ArrowLeftIcon";

export { ArrowLeft, ArrowLeft as default };
